/* eslint react/jsx-no-bind:0 */
import React, { Component } from "react"
import { PropTypes } from "prop-types"

const btnStyle = {
	fontSize:'13px',
	marginLeft:'4px',
	width:'185px',
	padding:'6px 3px',
	opacity:'.9'
}

class Steps extends Component {
	constructor(props)
  {
		super(props)
		this.handleGoTo = this.handleGoTo.bind(this)    
		this.generateSteps = this.generateSteps.bind(this)
	}
	
	handleGoTo(step)
	{
		this.props.goTo(step)
	}	

	generateSteps() {
		const { steps } = this.props;
		const wizardStep = steps.map((step) => {
		const  { disabled, label, current ,completed, sequence } = step;
		const className = current === true ? "btn btn-primary":"btn btn-default";
		const icon = current === true ? 'fa fa-edit':completed === true ? 'fa fa-check':disabled === true ? 'fa fa-ban':null;
		const iconStyle = (disabled === true && current === false) ? { color:'red' }:{};
		const color = completed === true ? 'green': current === true ? 'white': disabled === true ? 'gray':'black';
		return (<div className="form-group" key={sequence}>
			<button className={className} style={{ ...btnStyle, color }} onClick={() => this.handleGoTo(sequence)} disabled={disabled}>
				<i className={icon} aria-hidden="true" style={ iconStyle }/>&nbsp;&nbsp;{sequence}.&nbsp;{label}
			</button>
		</div>)
		})
		return wizardStep;
	}	
	render() {
		return (
			<div className="form-inline">
				{ this.generateSteps()}
			</div>						
		)
	}
}

Steps.propTypes = {
	steps: PropTypes.array.isRequired,
	goTo: PropTypes.func.isRequired,
};
export default Steps



// WEBPACK FOOTER //
// ./src/components/common/wizard/components/steps.js